import '../../styles/messages.css'
import '../../styles/tooltipsFiles.css'
import FeedbackIcons from '../../Containers/FeedbackIcons'
import { HighlightText } from './HighlightText'
import { TooltipDownload } from './TooltipsDocLinks'
import { ReactComponent as DownloadIcon } from '../../img/downloadIconSVG.svg'

const DocumentComponent = ({ documents, queryId, actions }) => {
    const { message, files } = documents

    return (
        <div className="message-container">
            {message && <p>{message}</p>}
            {files.map((doc) => (
                <div key={doc.resultId}>
                    <p><HighlightText text={doc.text} highlights={doc.highlights} /></p>

                    <div className="document-container">
                        <a
                            href={doc.openLink}
                            className="document-link"
                            target="_blank" rel="noopener noreferrer"
                            aria-label={`Baixar arquivo: ${doc.fileName}`}
                        >
                            {`Leia mais: ${doc.fileName}`}
                        </a>

                        <TooltipDownload>
                            <a href={doc.downloadLink} download>
                                <DownloadIcon className="downloadIcon" />
                            </a>
                        </TooltipDownload>
                    </div>
                    <FeedbackIcons queryId={queryId} resultId={doc.resultId} actions={actions} />
                </div>
            ))}
        </div>
    )
}

export default DocumentComponent